import { string } from "prop-types"

const GenericBlankState = ({ message }) => {
  return <div className="c-neutral-600">{message}</div>
}

GenericBlankState.propTypes = {
  message: string
}

export default GenericBlankState
